<ion-header *ngIf="userType !== 'coach'">
  <app-header [backRoute]="['/coach/appointments']"></app-header>
</ion-header>
<ion-header *ngIf="userType === 'coach'">
  <app-header [backRoute]="['/coach/requests-incoming']"></app-header>
</ion-header>
<ion-content class="content">
  <div class=" video-chat-container content-padding-top">
    <div class="user-video" *ngIf="!showSettingUp">
      <div class="bounds" *ngIf="!showSettingUp">
        <!-- Main video -->
        <div *ngIf="localUser && localUser.streamManager" #mainStream class="OT_root OT_publisher OT_main custom-class"
          id="localUser" (click)="toggleButtonsOrEnlargeStream($event)">
          <stream-component #streamComponentLocal class="mobile-float" [user]="localUser"></stream-component>
        </div>

      </div>
      <div class="user-photo" *ngIf="!localUser.streamManager"><img src="assets/img/icon-no-user-photo.svg" alt=""
          srcset="">
      </div>
      <div class="user-info">
        <div class="participant-name">{{selfName}}</div>
        <div class="participant primary-color" *ngIf="selfRole === 'delegate'">{{'__VIDEOCHAT_PARTICIPANT__' | translate}}</div>
        <div class="participant primary-color" *ngIf="selfRole === 'coach'">{{'__VIDEOCHAT_COACH__' | translate}}</div>
      </div>
    </div>
    <div class="video" id="layout" #layout>
      <div class="await-session" *ngIf="!showSettingUp && !sessionStarted">
        <div class="frame top-frame">
          <img src="assets/img/frame-top-left.svg" />
          <img src="assets/img/frame-top-right.svg" />
        </div>
        <div class="box">
          <div class="title-waiting-room"><span class="my-color-blue">{{'__VIDEOCHAT_WAITING_ROOM__' | translate}}</span></div>
          <div class="session-remain">
            <span class="description-text">{{'__VIDEOCHAT_SESSION_BEGINS_IN__' | translate}}</span>
            <app-timer-dial [timerTrigger]="timerTrigger" [secLeft]="secLeft" [secTotal]="secTotal">
              <app-timer-counter [timerTrigger]="timerTrigger" [secLeft]="secLeft" [secTotal]="secTotal"
                                 (timeOut)="onTimeOut()"></app-timer-counter>
            </app-timer-dial>
          </div>
          <div class="test">
            <span>{{'__VIDEOCHAT_SETTING_UP_YOUR_DEVICES__' | translate}}</span>
            <div class="btn-group">
              <div class="btn" (click)="openSettingUp()">
                <button>
                  <img src="assets/img/icon-microfone-white.svg" />
                </button>
                <span>{{'__VIDEOCHAT_AUDIO_SETTINGS__' | translate}}</span>
              </div>
              <div class="btn" (click)="openSettingUp()">
                <button>
                  <img src="assets/img/icon-video-white.svg" />
                </button>
                <span>{{'__VIDEOCHAT_VIDEO_SETTINGS__' | translate}}</span>
              </div>
              <!--div class="btn" (click)="join()">
                <button>
                  <img src="assets/img/join-session.svg" />
                </button>
                <span>Join Session</span>
              </div -->
            </div>
          </div>
        </div>

        <div class="frame bottom-frame">
          <img src="assets/img/frame-bottom-left.svg" />
          <img src="assets/img/frame-bottom-right.svg" />
        </div>
      </div>

      <div class="active-call" *ngIf="sessionStarted">
        <div class="bounds" *ngIf="!showSettingUp">
          <img class="recording-btn" *ngIf="recordingStarted" src="assets/img/icon-recording.svg">
          <div class="session-timer-container">
            <app-timer [secTotal]="sessionSecTotal" [secLeft]="sessionSecLeft"></app-timer>
          </div>
          <div class="await-remotes" *ngIf="remoteUsers.length === 0">{{'__VIDEOCHAT_WAITING_FOR_OTHER_PARTICIPANT__' | translate}}</div>
          <button class="endcall  btn-rounded-blue" *ngIf="sessionStarted" (click)="exitSession()">
            <img src="assets/img/icon-endcall-grey.svg" />
            <span>{{'__VIDEOCHAT_END_SESSION__' | translate}}</span>
          </button>
          <!-- Remotes -->
          <div class="remote-user-container" *ngIf="remoteUsers.length > 0">
            <div class="OT_root OT_publisher OT_remote custom-class" id="remoteUsers"
              (click)="toggleButtonsOrEnlargeStream($event)">
              <stream-component #streamComponentRemotes [user]="remoteUsers[0]"></stream-component>
            </div>
          </div>
        </div>
      </div>

      <div class="setting-up" id="ovVideo" *ngIf="showSettingUp && localUser && localUser.streamManager">
        <ov-video [streamManager]="localUser.streamManager" [isBackCamera]="localUser.isBackCamera()"></ov-video>
      </div>
    </div>
    <div class="bar" [ngClass]="{'bar-opened': isSidebarOpened()}">

      <app-chat
              (onClose)="showChat=!showChat" *ngIf="showChat && currentSession"
              [currentSession]="currentSession"
              [user]="localUser"
              [userInfo]="userInfo"
              @enter>
      </app-chat>
      <div class="btn chat" (click)="onDocClick()" *ngIf="!isSidebarOpened()">
        <div class="vl"></div>
        <div class="changeToFull">
          <img src="assets/img/icon-chat.svg" />
          <span>Chat</span>
          <div *ngIf="false" class="active-msg">3</div>
        </div>
      </div>


      <app-setting-up
              (onAdd)="closeSettingUp()"
              [localUser]="localUser"
              [OV]="OV"
              [audioDevices]="audioDevices"
              [videoDevices]="videoDevices"
              *ngIf="showSettingUp" @enter>
      </app-setting-up>
    </div>
  </div>
  <app-footer-logo *ngIf="!isSidebarOpened()"></app-footer-logo>
</ion-content>


<ion-footer class="footer" [ngClass]="{'footer-opened': isSidebarOpened()}">
  <div class="btn-upper-panel">
    <div class="empty-conteiner"></div>
    <button class="btn-cancel-call btn-round" *ngIf="isSidebarOpened()" (click)="exitSession()"
      [ngClass]="{'btn-active-call': sessionStarted == true}"><img src="assets/img/icon-endcall-grey.svg" /></button>
    <div class="btn-right-side">

      <button class="close btn-round" (click)="hideWidePanel()" *ngIf="isSidebarOpened()"><img class="close"
          src="assets/img/arrow-down.svg" /></button>
    </div>
  </div>
  <div class="desktop-footer">
    <div class="callingTo">
      <img src="assets/img/icon-user.svg" />
      <span>{{selfName}}</span>
    </div>
    <div class="video-panel" *ngIf="sessionStarted">
      <button (click)="micStatusChanged()" *ngIf="!disableMic" [disabled]="!sessionStarted"><img
        src="assets/img/icon-microfone.svg" /></button>
      <button class="btn-off" (click)="micStatusChanged()" *ngIf="disableMic" [disabled]="!sessionStarted"><img
              src="assets/icon/white-microphone.svg" /></button>

      <button (click)="camStatusChanged()" *ngIf="!disableVid" [disabled]="!sessionStarted"><img
          src="assets/img/icon-video.svg" /></button>
      <button class="btn-off" (click)="camStatusChanged()" *ngIf="disableVid" [disabled]="!sessionStarted"><img
              src="assets/icon/white-cam.svg" /></button>

      <button (click)="openSettingUp()"><img
              src="assets/icon/settings-icon.svg" /></button>
      <button *ngIf="false" [disabled]="!sessionStarted"><img src="assets/img/icon-share.svg" /></button>
      <button *ngIf="false"><img src="assets/img/icon-full-screen.svg" /></button>
    </div>
    <div class="video-panel" *ngIf="!sessionStarted">
      <button class="btn-disabled" (click)="micStatusChanged()" [disabled]="!sessionStarted"><img
              src="assets/img/icon-microfone.svg" /></button>
      <button class="btn-disabled" (click)="camStatusChanged()" [disabled]="!sessionStarted"><img
              src="assets/img/icon-video.svg" /></button>
      <button (click)="openSettingUp()"><img
              src="assets/icon/settings-icon.svg" /></button>
      <button class="btn-disabled" *ngIf="false"  [disabled]="!sessionStarted"><img src="assets/img/icon-share.svg" /></button>
      <button class="btn-disabled" *ngIf="false"  [disabled]="!sessionStarted"><img src="assets/img/icon-full-screen.svg" /></button>
    </div>

    <div class="recording" *ngIf="!recordingStarted">
      <span>{{'__VIDEOCHAT_START_RECORDING__' | translate}}</span>
      <img (click)="toggleRecording()" src="assets/icon/start-recording-btn.svg" />
    </div>
    <div class="recording" *ngIf="recordingStarted">
      <span>{{'__VIDEOCHAT_STOP_RECORDING__' | translate}}</span>
      <img (click)="toggleRecording()" src="assets/icon/stop-recording-btn.svg" />
    </div>

  </div>
  <div class="mobile-footer">
    <div class="first-row">
      <div class="callingTo">
        <img src="assets/img/icon-user-white.svg" />
        <span>{{selfName}}</span>
      </div>
      <div class="recording" *ngIf="!recordingStarted">
        <span>{{'__VIDEOCHAT_START_RECORDING__' | translate}}</span>
        <img (click)="toggleRecording()" src="assets/icon/start-recording-btn.svg" />
      </div>
      <div class="recording" *ngIf="recordingStarted">
        <span>{{'__VIDEOCHAT_STOP_RECORDING__' | translate}}</span>
        <img (click)="toggleRecording()" src="assets/icon/stop-recording-btn.svg" />
      </div>
    </div>
    <app-documents (onAdd)="showDocs=!showDocs" *ngIf="showDocs"></app-documents>
    <app-chat
            (onClose)="showChat=!showChat" *ngIf="showChat && currentSession"
            [currentSession]="currentSession"
            [user]="localUser"
            [userInfo]="userInfo">
    </app-chat>
    <app-notes (onAdd)="showNotes=!showNotes" *ngIf="showNotes"></app-notes>
    <app-setting-up
            (onAdd)="closeSettingUp()"
            [localUser]="localUser"
            [OV]="OV"
            [audioDevices]="audioDevices"
            [videoDevices]="videoDevices"
            *ngIf="showSettingUp">
    </app-setting-up>

    <div class="panel" *ngIf="!isSidebarOpened()">
      <button class="btn microfone" [ngClass]="{'btn-off': disableMic === true, 'btn-disabled': !sessionStarted}" (click)="micStatusChanged()" [disabled]="!sessionStarted">
        <div class="changeToFull ">
          <img class="microfone-icon" src="assets/img/icon-microfone.svg"
            [ngClass]="{'btn-off': disableMic === true, 'btn-disabled': !sessionStarted, 'display-none' : disableMic === true}" />
          <img class="microfone-icon" src="assets/icon/light-grey-mic.svg" [ngClass]="{'display-none' : disableMic === false, 'display-flex': disableMic === true}" />

        </div>
      </button>
      <button class="btn video" (click)="camStatusChanged()" [ngClass]="{'btn-disabled': !sessionStarted, 'btn-off': disableVid === true}" [disabled]="!sessionStarted">
        <div class="changeToFull">
          <img class="video-icon" src="assets/img/icon-video.svg" [ngClass]="{'btn-off': disableVid === true, 'btn-disabled': !sessionStarted, 'display-none' : disableVid === true}" />
          <img class="video-icon" src="assets/icon/light-grey-cam.svg" [ngClass]="{'display-none' : disableVid === false, 'display-flex': disableVid === true}" />
        </div>
      </button>

      <button class="btn endCall" (click)="exitSession()" [disabled]="!sessionStarted">
        <div class="endCall-box btn-round">
          <div class="changeToFull btn-round" [ngClass]="{'btn-active-call': sessionStarted}">
            <img src="assets/img/icon-endcall-grey.svg" />
          </div>
        </div>
      </button>

      <button class="btn settings" (click)="openSettingUp()">
        <img src="assets/icon/settings-icon.svg" />
      </button>
      <div class="btn chat " (click)="onDocClick()">
        <div class="changeToFull">
          <img class="chat-icon" src="assets/img/icon-chat.svg" />
          <span>{{'__VIDEOCHAT_CHAT_HEADER__' | translate}}</span>
        </div>
      </div>

    </div>
  </div>
</ion-footer>
